export enum PATH {
  API = "api",
  API_DOCS = "api-docs",
  FILE = "file",
  SPORT = "sport",
  LEAGUE = "league",
  TEAM = "team",
  TEAM_ADS = "teamads",
  TEAM_ADS_FOR_TEAM = "teamadsforteam",
  TEAM_POPUPS = "teampopups",
  TEAM_POPUPS_FOR_TEAM = "teampopupsforteam",
  TEAM_CLIENT_SERVICE = "team-client-service",
  CLIENT_SERVICE = "client-service",
  OPERATOR = "operator",
  SPORT_DATA = "sport-data",
  STATE = "state",
  GAME = "game",
  SEASON = "season",
  HOMESTAND = "homestand",
  AUTH = "auth",
  STADIUM = "stadium",
  TEMPLATE = "ticket-template",
  TICKET_FONT = "ticket-font",
  CITY = "city",
  POPULATED = "populated",
  CAMERA = "camera",
  LIST = "list",
  ITEM = "item",
  NAME = "name",
  PREVIEW = "preview",
  SEATING_CONFIGURATIONS = "seating-configurations",
  STADIUM_UPDATE_SEATING_CONFIG = "update-seating-configuration",
  PREPARE_IMAGES = "prepare-images",
  UPLOAD_MOTG_IMAGE = "upload-motg-image",
  UPLOAD_LARGE_MOTG_IMAGE = "upload-large-motg-image",
  UPLOAD_PURCHASE_IMAGE = "upload-purchase-image",
  UPDATE_USERS_UNIQUE_URLS = "update-users-unique-urls",
  CLEAR_USERS_UNIQUE_URLS = "clear-users-unique-urls",
  UPDATE_USERS_SEAT_URLS = "update-users-seats-urls",
  CREATE_NEW_USERS = "create-new-users",
  MOMENT = "moment",
  CHECK = "check",
  CHECK_LAST_NAME = "check-last-name",
  STATUS = "status",
  MARK_OPERATOR_GAME_LIVE = "mark-operator-game-live",
  UPDATE_GAME_TICKET_TEMPLATE = "update-game-ticket-template",
  UPDATE_GAME_TICKET_TEMPLATES = "update-game-ticket-templates",
  UPDATE_GAME_IS_PAID_GAME = "update-game-is-paid-game",
  UPDATE_GAME_SHOW_PRINT_ORDER_BUTTON = "update-game-show-print-order-button",
  UPDATE_GAME_CHECK_LAST_NAME = "update-game-check-last-name",
  UPDATE_GAME_DEV_GAME = "update-game-dev-game",
  UPDATE_GAME_SECONDARY_LOGO = "update-secondary-logo",
  UPDATE_GAME_SECONDARY_PRIMARY_COLOR = "update-secondary-primary-color",
  GAME_SEATS = "game-seats",
  GAME_SECTIONS = "game-sections",
  LINKED_SEATS = "linked-seats",
  SEAT_GROUPS = "seat-groups",
  OPT_OUTS = "opt-outs",
  OPT_OUT = "opt-out",
  SEASON_OPT_OUTS = "season-opt-outs",
  UPDATE_SEAT_GROUPS_UNIQUE_URLS = "update-seat-groups-unique-urls",
  CLEAR_SEAT_GROUPS_UNIQUE_URLS = "clear-seat-groups-unique-urls",
  UPDATE_SEAT_GROUPS_SEAT_URLS = "update-seat-groups-seat-urls",
  NOTIFY = "notify",
  INFO = "info",
  LINK = "link",
  ROTATE = "rotate",
  ALL = "all",
  GENERAL = "general",
  SYSTEM = "system",
  OVERLAYS = "overlays",
  IMAGE = "image",
  COMPRESSED = "compressed",
  CROPPED = "cropped",
  SEATING_CONFIG = "seating-config",
  SECTIONS = "sections",
  CAMERA_FROM_STADIUM_ACTIVE_SEATING_CONFIGURATION = "cameraFromStadiumActiveSeatingConfiguration",
  CONFIG = "config",
  CROPPED_EXPERIMENTAL = "cropped-experimental",
  CROPPED_VIDEO = "cropped-video",
  IMAGE_KEY = "image-key",
  PRERENDER_MOMENT = "prerender-moment",
  GET_RENDER_URL = "get-render-url",
  HEALTH = "health",
  USER = "user",
  SPECIAL_SECTIONS = "special-sections",
  ALL_SECTIONS = "all-sections",
  PAYMENT = "payment",
  GET_ALL_PAYMENTS = "get-all-payments",
  ADD_UPDATE_PAYMENT = "add-update-payment",
  ADD_PENDING_PAYMENT = "add-pending-payment",
  SHOPIFY_WEBHOOK = "shopify-webhook",
  CHECK_GAME_IS_PAID = "check-game-is-paid",
  ANALYZE = "analyze",
  ANALYZE_PROGRESS = "analyze-progress",
  TRIGGER_SECTION_IMAGE_GEN = "triggerSectionImageGeneration",
  SUPERADMIN_MANUAL_DRAFT_CAMERAS = "superadmin/manual-draft/cameras",
  SUPERADMIN_MANUAL_DRAFT_S3_LIST = "superadmin/manual-draft/s3-list",
  SUPERADMIN_MANUAL_DRAFT_S3_PREVIEW = "superadmin/manual-draft/s3-preview",
  SUPERADMIN_MANUAL_DRAFT_PREPARE = "superadmin/manual-draft/prepare-upload",
  SUPERADMIN_MANUAL_DRAFT_COMMIT = "superadmin/manual-draft/commit",
  MASKED_SEAT_IMAGE_GEN = "maskedSeatImageGeneration",
  GET_LAST_SESSION = "get-last-session",
  UPDATE_USER_SESSION = "update-user-session",
  SAVE_PURCHASE_LINK = "save-purchase-link",
  RESERVE_PRINT_ORDER_NUMBER = "reserve-print-order-number",
  GET_IMAGE_LINK = "get-image-link",
  CONVERT_TO_JPEG = "convert-to-jpeg",
  MEDIACLIP_GET_USER_TOKEN = "mc-get-user-token",
  MEDIACLIP_GET_BEAUTY_SHOT = "mc-get-beauty-shot",
  MEDIACLIP_GET_BEAUTY_SHOT_WITH_USER_ID = "mc-get-beauty-shot-with-user-id",
  LAMBDA = "lambda",
  GET_PROVISIONED_CONCURRENCY_CONFIG = "get-provisioned-concurrency-config",
  PUT_PROVISIONED_CONCURRENCY_CONFIG = "put-provisioned-concurrency-config",
  DELETE_PROVISIONED_CONCURRENCY_CONFIG = "delete-provisioned-concurrency-config",
  LOG_ACTION = "log-action",
  TRACK_ACTION = "track-action",
  PRE_SIGNED_UPLOAD = "pre-signed-upload",
  LIST_DOWNLOAD_FOLDERS = "list-download-folders",
  LIST_DOWNLOAD_SUBFOLDERS = "list-download-subfolders",
  LIST_DOWNLOAD_IMAGES = "list-download-images",
  LIST_FAN_DOWNLOADS = "list-fan-downloads",
  VIDEOBOARD_APPROVE = "videoboard-approve",
  VIDEOBOARD_DENY = "videoboard-deny",
  VIDEOBOARD_PUBLISH = "videoboard-publish",
  VIDEOBOARD_DELETE = "videoboard-delete",
  VIDEOBOARD_UPLOAD_PRESIGN = "videoboard-upload-presign",
  LIST_PRINT_FOLDERS = "list-print-folders",
  LIST_PRINT_IMAGES = "list-print-images",
  USER_DOWNLOADS = "user-downloads",
  FAN_AUTH = "fan-auth",
  LOGIN = "login",
  RESET_PASSWORD = "reset-password",
  REGISTER = "register",
  S3_UPLOAD_URL = "s3-upload-url",
  S3_UPLOAD_COMPLETE = "s3-upload-complete",
  S3_DOWNLOAD_URL = "s3-download-url",
  S3_DOWNLOAD_COMPLETE = "s3-download-complete",
  PERSONALIZED_EMAILS_EXPORT = "personalized-emails-export",
  BATCH_UPLOAD = "batch-upload",
  PRESIGNED_UPLOAD = "presigned-upload",
  PROCESS_UPLOADED_FILE = "process-uploaded-file",
  DELETE = "delete",
  PROGRESS = "progress",
  SUPPORT = "support",
  MONITORING = "monitoring",
  SNAPS = "snaps",
  FILES = "files",
  MOMENT_NOTIFY_SUBSCRIBERS = "moment-notify-subscribers",
  MOMENT_NOTIFY_EMAIL_PREVIEW = "moment-notify-email-preview",
  MOMENT_NOTIFY_SEND_EMAIL = "moment-notify-send-email",
  PROFILE_RELIVE_EMAIL_PREVIEW = "profile-relive-email-preview",
  PROFILE_RELIVE_EMAIL_SEND = "profile-relive-email-send",
}

export enum STORAGE_CONTEXT {
  GAME_SEATS = "gameSeats",
  GAME_SEATS_RESULTS = "gameSeatsResults",
}

export const MappingConstants = {
  DEFAULT_SEAT_RADIUS: 80,
  DEFAULT_IMAGE_MARGIN_PIXELS: 80,
  DEFAULT_SEAT_FACE_X_OFFSET: 0,
  DEFAULT_SEAT_FACE_Y_OFFSET: 0,
};
